// extracted by mini-css-extract-plugin
export default {"txt":"style_txt__t9K6N","paragraph":"style_paragraph__EqGxD","textList":"style_textList__-0+g3","info":"style_info__zdTx5"};